var en = {

	login_title: "Cloud Speaker Management System",
	login_ckcode: "Verification code",
	login_button: "Log in",
	login_account: 'Please enter the account number',
	login_password: 'Please enter password',
	reset_password: 'Reset password',
	new_password: 'New password',
	sure_password: 'Confirm password',
	password_error:"The password cannot be empty",
	password_error_2:"The two inputs are inconsistent",
	password_error_3:"The password must contain at least eight characters, including uppercase letters, lowercase letters, digits, and special symbols",
	app_sure: 'Confirm',
	app_cancel: 'Cancel',
	app_comment: 'Shenzhen Zhengtong Electronic Co., Ltd. © 1993-2023 copyright Guangdong ICP B No. 12035887',
	app_input: 'Please enter the content',

	app_sign_out:"Sign out",
	app_sign_out_message:"Are you sure to log out?",
	app_all_total: 'Total broadcasts',
	app_yesterday_total: "yesterday broadcasts",
	app_device_total: 'Total devices',
	app_strokes:"",
	app_units:"",
	app_yesterday_active: "Active devices yesterday",
	app_start_time: "Start date",
	app_end_time: "End date",
	app_device_equi: "Equipment statistics",
	app_broad_statis: "Broadcast statistics",
	app_active: 'Active',
	app_off_line: "Offline",
	app_un_init: "Inactivated",
	app_success: 'Success',
	app_pushed: "Pushed",
	app_device_ofline: 'Device offline',
	app_failed: "Failure",
	app_day: "Days",
	app_hour: 'Hours',
	app_minute: 'm',
	app_second: 's',
	app_millisecond: "ms",


	app_bind: "Bind",
	app_unbind: 'Unbind',
	app_mulAdd: 'Batch add',
	app_batch_import: "Batch import",
	app_bind_all: 'Batch bind',
	app_unbind_selected: "Unbind selected",
	add_selected: "Add selected",
	add_all: "Add all",
	app_select: 'Select',
	app_blur: "Blur",
	app_search: "Search",
	app_delete_select: "Delete Selected",
	app_delete_all: "Delete All",
	app_delete_question: "Are you sure to delete data?",
	app_delete_question_2: "Are you sure to delete this data?",
	app_range_error: "The overstart range cannot be greater than the end range",
	app_operation: 'Operation',
	app_detail: 'Detail',
	app_delete: "Delete",
	app_move: "Move",
	app_nums: 'Numbers',
	app_content: 'Content',
	app_not_update: "Not updated",
	app_update: "Updated",
	app_sure_unbind: 'Are you sure you want to unbind?',
	app_sure_unbind_2: 'Are you sure to unbind these?',
	app_import_message: "Upload the completed template",
	app_import_sure: "Download the import template and fill in the information in batches",
	app_upload_template: "Upload template",


	app_select_sn: "Search SN",
	app_select_name: "Search name",

	app_add_task: "Add task",
	app_edit_task: "Edit task",
	app_task_name: "Task name",
	app_task_statement: "Task statement",
	app_bottom_pack: "System upgrade task",
	app_bottom_bag: "System version",
	app_upgrade_conditions: "Upgrade conditions",
	app_firmware_version: "Firmware version",
	app_file: 'file',
	app_other: 'other',

	
	menu: {
		home: "Home Page",
		device_management: "Device management",
		device_detail: "Device detail",
		merchant_management: "Merchant management",
		merchant_detail: "Merchant detail",
		channel_vendor_management:"Distributor management",
		channel_vendor_detail:"Customer detail",
		personal_information:"Personal information",
		platform_configuration:"Platform configuration",
		model_management:"Model management",
		account_management:"Account management",
		parameter_management:"Parameter management",
		developer_management:"Developer management",
		upgrade_management:"Upgrade Management",
		import_task_management:"Import task management",
		device_assistant:"Device Assistant",
		task_details:"Task detail",
		subtask_details:"Subtask detail",
		login:"Log in",
		
	},
	
	
	terminal: {
		Match: 'Telecom Card Matching',
		MatchList: 'Matching List',
		matchName: 'Name',
		match_num: 'Quantity',
		match_status: 'Status',
		match_createTime: 'Import Time',
		match_updateTime: 'Completion Time',
		match_s: 'Completed',
		match_e: 'Incomplete',
		add_device: 'Add Device',
		edit_device: "Edit Device",
		import_btn: 'Import Device',
		pro_import: "Import From Production line",
		move_device: "Move Device",
		export_device: "Export device",
		modify_triplet: "Modify triplet",
		app_distributor: 'Distributor',
		device_status: "Device status",
		network_signal: "Network signal",
		sn_or_name: "Device SN or Name",
		device_sn: "Device SN",
		device_name: 'Device name',
		device_type: 'Device type',
		device_key: "Device Key",
		device_model: 'Device model',
		device_ip_address: "Device IP address",
		device_no: 'Device number',
		device_id: 'Device ID',
		search_device: "Search device",
		bound_merchant: "Bound merchant",
		binding_device: "Binding device",
		unbound_merchant: "unbound",
		last_online: "Last online time",
		last_offline: "Last offline time",
		dynamic_key: "Dynamic key",
		volume: "Volume",
		user_manual: "User manual setting",
		network_type: "Network type",
		platform: "Platform",
		default_platform: "Default Platform",
		aliyun: "Aliyun",
		ba_add_device: "Batch add devices",
		prefix: "Prefix",
		start_to_end: "Start to end number segment",
		order_number: "Order number",
		sure_unbind: "Are you sure to unbind device ",
		sure_unbind_2: "Are you sure to unbind device ?",
		sure_unbind_3: "Are you sure you want to detach these devices?",
		sure_delete_device: "Are you sure to delete all devices?",
		device_detail: "Device details",
		device_addtime: "Add time",
		device_acttime: "Activation time",
		device_list: "Device list",
		offline_time: 'Offline duration',
		current_network: "Current network",
		internet_signal: "Internet signal",
		device_power: "Device power",
		hardware_version: "Hardware version",
		wifi_version: "WiFi firmware version",
		GPRS_system_version: "GPRS System version",
		GPRS_firmware_version: "GPRS firmware version",
		user_audio_version: "User Audio Version",
		longitude: "Longitude",
		latitude: "Latitude",

		merchant_add_time: "Merchant addition time",
		app_contactPhone: 'contact number',
		sub_organization: "Organization",
		broad_num: "Number of broadcasts",
		cumulative_broadcast: "Cumulative broadcast",
		test_broadcast: "Test broadcast",
		broadcast_record: "Broadcast records",
		export_records: "Export records",
		serial_number: "Transaction number",
		branch_store: "Branch store",
		broadcast_template: "Broadcast template",
		broadcast_state: "Broadcast state",
		date_filter: "Date filter",
		app_amount: "Amount",
		broadcast_time: "Broadcast time",
		response_time: "Response time",
		broadcast_time_consuming: "Broadcast time-consuming",
		online_offline_records: "Active records",
		add_device_task: "Add a device to a task",
		bound_device_num: "Devices count",
		device_SN_Name: "Device SN/Name",
		binding_state: "Binding state",
		risk_name: 'Configuration name',
		risk_content: 'Configuration content',
		push_stauts: "Push status",
		export_config: "Export configuration",
		update_config_time: "Upgrade time",









		ztgxsj: 'Last updated',
		import_title: 'Import device information',
		xqwj: 'Select the file',
		qrdr: 'Are you sure to import?',
		import_muban: 'Download the import template',
		notify_title: 'Import results prompt',
		delete_tips: 'This operation will permanently delete the device, are you sure to continue?',
		deletes_tips: 'This operation will permanently delete the device, are you sure to continue?',
		empty_tips: 'Please select the device to be deleted',
		/*20170731新加*/
		excel_tips: 'Only Excel files not exceed 10M can be uploaded',
		
		
		
		
		up_smid:"Upgrade Alipay smid",
		smid:"Alipay smid",
		isShare:"isShare",
		yes:"Yes",
		no:"No",
		Binding_failure:"Binding failure",
		

	},

	merchant: {
		merchant_add: "Add merchant",
		export_merchant: "Exporting merchant",


		store_name: "Store name",
		merchant_id: "Merchant ID",
		merchant_name: "Merchant name",
		merchant_num: "Merchant number",
		merchant_can_num: "Channel number",
		merchant_tel: "Merchant telephone",
		merchant_pla: "00=Cash Register 01=Fusion Payment 02=Others",
		merchant_equ: "Add equipment to merchant",
		merchant_numbers: "Number of merchants",
		edit_channel: "Edit merchant",


		edit_merchant: "Edit merchant",
		import_merchant: "Import merchant",
		download_merchant_message: "Download the merchant import template and fill in the merchant information in batch",
		upload_merchant_device: "Upload the completed channel supplier template",
		branch_management: "Branch management",
		message_num: "Messages count",
		all_collection: "Cumulative amount",
		branch_number: "Branch number",
		add_branch: "Add branch",
		edit_branch: "Edit branch",
		branch_name: "Branch name",
		add_vendor: "Add Distributor",
		vendor_name: "Distributor Name",
		vendor_id: "Distributor ID",
		super_vendor: "Superior Distributor",
		equipment_quantity: "Equipment Quantity",
		channel_contact: "Contact person",
		contact_number: "Contact number",
		import_devices_vendors: "Import devices to Channel vendors",
		move_to_channel: "Move to the channel provider",
		channel_add_time: "Create time",
		binding_user: "Binding user",


		app_customer:"Customer",
		client_name: "Client name",
		input_client_name: "Input client name",
		mapping_sn: "Mapping SN",
		mapping_time: "Mapping time",
		add_mapping:"Add mapping",
		app_Platform: "Platform",



	},
	model: {
		app_model: 'model',
		add_model: "Add model",
		edit_model: "Edit model",
		self_tube: "self-tube",
		other_manage: "Other management",
	},
	deleloper: {
		add_develop: "Add developer",
		edit_develop: "Edit developer",
		develop_id: "Developer ID",
		develop_password: "Developer password",
		develop_name: "Developer name",
		develop_phone: "Developer phone",
		develop_email: "Developer email",
		develop_address: "Developer address",
		product_model: "Product model",



	},
	select_option: {
		bind: "Bind",
		un_bond: "Un bond",
		un_bind: "Un bind",
		app_enable: "Enable",
		app_disabled: "Disabled",
		app_youyoubao: "002T",
		pending_upgrade: "Pending upgrade",
		app_updated: "Updated",
		no_data: "No data",
		app_message_pushed: 'Pushed',
		app_notpushed: 'Not pushed',
	
		app_send: "Send",
		app_succeed:"Succeed",
		app_offline:"Offline",
		app_error: "Error",
		no_version:"Not equal to task version",
		less_version:"Less than task version",
		app_online:"Online",
		
		all_status:"All status",
		go_line:"Online",
		go_offline:"Offline",
		app_update:"Update",
		
		app_agent: 'Agent',
		app_admin:"Admin",
		app_ordinary:"Ordinary",
		app_production:"Production",
		
		app_task_import:"Upgrade task import",
		app_device_import:"Device import"
	},
	
	

	app_update_status: "Upgrade status",
	app_file_error: "Convey the upper limit on the file, please remove it before uploading",
	app_createTime: 'Create time',
	app_upload: 'Upload',
	app_clickUpdate: 'Click upload',
	app_download: "Download",
	app_imp: 'Import',
	app_derive: 'Export',
	app_download_template: "Download template",
	app_upload_template: "Upload template",
	app_download_device_message: "Download the device import template and fill in the device information in batches",
	app_unupload_file: "Unuploaded file",
	app_upload_completed_device: "Upload the completed device template",
	app_delete_bind: "Are you sure to delete the binding?",
	app_delete_bind_2: "Are you sure to delete these bindings?",
	app_delete_association: "Are you sure to delete the association?",
	app_choose_version: "Choose version",
	app_choose_platform: "Choose platform",
	app_choose_model: "Choose a model",
	app_choose_vendor: "Choose Channel vendor",
	app_input_num: 'Please enter quantity',
	app_input_start: 'Enter a numeric start segment',
	app_mot: "Modify triples in batches",
	app_file_invalid: "The file format is invalid",
	app_status: 'Status',
	app_time: 'Time',
	app_mulDel: 'Batch deleted',
	app_add_time: "Add time",
	app_import_result: "Import result",
	app_description: "description",
	app_update_time: "Upgrade time",
	app_no_role: "No action for this role",
	app_add_account: "Add account",
	app_edit_account: "Edit account",
	app_select_account: "Select account",
	app_login_account: "Account",
	app_nick_name: 'Nickname',
	app_mobile_phone: "Mobile phone",
	app_aliyun: "Aliyun Key",
	app_provider: "Distributor",
	app_role: "Role",
	app_telephone: "telephone",
	app_enable: "Enable",
	app_disabled: "Disabled",
	app_phone_number: "Phone number",
	app_modify_data: "Modify",
	app_change_password: "Change Password",
	app_current_password: "Current password",
	app_new_password: "New password",
	app_new_password_2: "Confirm new password",
	app_pasword_error: "The new password is different from the confirmed password",
	app_message_pushed: 'Pushed',
	app_notpushed: 'Not pushed',
	app_email: "Email",
	app_addres: 'Address',
	app_wifi_pla: 'Please fill in the Wi-Fi firmware version, if it is empty, it will not be upgraded',
	app_wifi_pla_2: 'Please fill in the Wi-Fi version number before upgrade',
	app_gprs_pla: 'Please fill in the GPRS firmware version, if it is empty, it will not be upgraded',
	app_gprs_pla_2: 'Please fill in the GPRS version number before upgrade',
	app_audio_pla: 'Please fill in the user audio version, if it is empty, it will not be upgraded',
	app_wifi_version: "Wi-Fi based version",
	app_gprs_version: "GPRS Firmware version",
	app_gprs_version_2: "GPRS based version",
	app_audio_version: "User audio version",
	app_yes: 'Yes',
	app_no: 'Cancel',
	app_addsubts: 'Add subtasks',









	app_disassociate: "Disassociate",
	app_name: 'Name',
	app_query: 'Query',
	app_reset: 'Reset',
	app_cancel: 'Cancel',
	app_edit: 'Edit',
	app_add: 'Add',
	app_verify: 'Review',
	app_isPass: 'Result',
	app_pass: 'Approved',
	app_ban: 'Rejected',
	app_noInput: 'Unfilled',
	app_banReason: 'Refuse reason',
	app_filter: 'Filter',
	app_prePushVerify: 'Waiting for submitting',
	app_preVerify: 'waiting for review',
	app_verifyPass: 'Approved',
	app_verifyNotPass: 'Rejected',
	app_submit: 'Submit',
	app_tip: 'Prompt',
	app_online: 'Online',
	app_offline: 'Offline',
	app_fileOver: 'File exceed',
	app_onlyApk: 'Apk files upload only',
	app_tipViewTask: 'Push successfully, please view progress in task management',
	app_tipMkDel: 'Application in app store will be deleted synchronously. Are you sure to delete?',
	app_tipAppEdit: 'Deleted will not be restored, sure to delete?',
	app_tipVerify: 'Are you sure to submit?',
	app_rqsError: 'Request error',

	app_import_type: "Import type",
	app_describe: "Describe",
	app_total_amount: "Total count",
	app_success_number: "Success number",
	app_failure_number: "Failure number",
	app_execution_time: "Execution time",

	app_sn_pla:"Please enter device SN",
	app_task_pla:"Please enter task name",



}

export default en;
